export const isHK = function(area) {
  if (area === "HK") {
    return true;
  }
  return false;
};
